import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerScanAbnormalLockListDataApi(data) {
  return request({
    url: "web/appConsumerScanAbnormalLock/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppConsumerScanAbnormalLockExportDataApi(data) {
  return request({
    url: "web/appConsumerScanAbnormalLock/exportData",
    method: "post",
    data
  });
}
// 初始化
export function initAppConsumerScanAbnormalLockApi(data) {
    return request({
        url: "web/appConsumerScanAbnormalLock/init",
        method: "post",
        data
    });
}
  
// 操作
export function saveOrUpdateAppConsumerScanAbnormalLockApi(data) {
    return request({
        url: "web/appConsumerScanAbnormalLock/saveOrUpdate",
        method: "post",
        data
    });
}